import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormErrorMessage from '../../../errors/FormErrorMessage';

const ERROR_MESSAGE = 'EventOPS integration error';

class SafetyWrapper extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    state = {
        hasError: false,
    };

    componentDidCatch() {
        this.setState({ hasError: true });
    }

    render() {
        return this.state.hasError ? <FormErrorMessage errorType={ERROR_MESSAGE} /> : this.props.children;
    }
}

export default (WrappedComponent) => (props) =>
    (
        <SafetyWrapper>
            <WrappedComponent {...props} />
        </SafetyWrapper>
    );
